import { Group, Modal, Text } from '@mantine/core';
import { Button } from 'src/design-system/Button';

type Props = {
  opened: boolean;
  count: number;
  isGenerating?: boolean;
  onClose: () => void;
  onIdentify: () => void;
  onContinue: () => void;
};

export function UnidentifiedSpeakersWarningModal({
  opened,
  count,
  isGenerating,
  onClose,
  onIdentify,
  onContinue,
}: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title="Unidentified speakers" centered size={440}>
      <Text size="textSm" c="gray.7">
        {count === 1 ? '1 speaker is' : `${count} speakers are`} still unidentified. The meeting
        note may attribute statements to the wrong person. Identify them for the most accurate note,
        or continue and regenerate the note once they&apos;re identified.
      </Text>
      <Group justify="flex-end" gap="sm" mt="lg">
        <Button variant="secondary" onClick={onIdentify} disabled={isGenerating}>
          Identify speakers
        </Button>
        <Button variant="primary" onClick={onContinue} loading={isGenerating}>
          Continue anyway
        </Button>
      </Group>
    </Modal>
  );
}
